import { render, staticRenderFns } from "./CustomRadios.vue?vue&type=template&id=0bcfae5c&scoped=true&"
import script from "./CustomRadios.vue?vue&type=script&lang=js&"
export * from "./CustomRadios.vue?vue&type=script&lang=js&"
import style0 from "./CustomRadios.vue?vue&type=style&index=0&id=0bcfae5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcfae5c",
  null
  
)

export default component.exports